module["exports"] = [
  "Apt. ###",
  "Zimmer ###",
  "# OG"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de/address/secondary_address.js
 ** module id = 324
 ** module chunks = 0
 **/